import { createSlice } from "@reduxjs/toolkit";

const crsytal=createSlice({
  name:"crsytal",
  initialState:{num:0},
  reducers:{
    setCrsytalS:(state,action)=>{
      state.num=action.payload
    }
  }
});

export const {setCrsytalS}=crsytal.actions
export default crsytal.reducer